import axios from "axios";
import {
    AUTH_REQUEST,
    AUTH_SUCCESS,
    AUTH_ERROR,
    STEP1,
    STEP2,
    EVENT_CREATED,
    PASSWORDRESET,
    PASSRESETERROR,
    PASSWORDCHANGED,
    PASSWORDSETERROR
} from "./types";
const baseURL = "http://tid.nu/public/api/";
const actions = {
    async login({ commit }, user) {
        try {
            user.url = `${baseURL}login`;
            commit(AUTH_REQUEST);
            var resp = await axios(user);
            const token = resp.data.token;
            user = resp.data.user;
            axios.defaults.headers.common["Authorization"] = token;
            commit(AUTH_SUCCESS, { token, user, msg: "Logga in framgång" });
        } catch (err) {
            commit(AUTH_ERROR, {
                msg:
                    "Inloggning misslyckades (ogiltigt användarnamn eller lösenord)"
            });
            localStorage.removeItem("token");
        }
    },

    register({ commit }, user) {
        user.url = `${baseURL}register`;
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios(user)
                .then(resp => {
                    const token = resp.data.token;
                    user = resp.data.user;
                    axios.defaults.headers.common["Authorization"] = token;
                    commit(AUTH_SUCCESS, {
                        token,
                        user,
                        msg: "Registrering lyckad"
                    });
                    resolve(resp);
                })
                .catch(err => {
                    console.log(err);
                    commit(AUTH_ERROR, {
                        msg: "Kontot med den här e-postadressen finns redan!"
                    });
                    localStorage.removeItem("token");
                    reject(err);
                });
        });
    },
    logout({ commit }) {
        return new Promise(resolve => {
            commit("LOGOUT");
            localStorage.removeItem("token");
            delete axios.defaults.headers.common["Authorization"];
            resolve();
        });
    },
    step1({ commit }, config) {
        commit(STEP1, config);
    },

    step2({ commit }, config) {
        commit(STEP2, config);
    },
    async createEvent({ commit }, config) {
        try {
            config.url = `${baseURL}newevent`;
            let resp = await axios(config);
            let link = resp.data.link;
            commit(EVENT_CREATED, link);
        } catch (err) {
            console.log(err);
        }
    },
    async passreset({ commit }, config) {
        try {
            config.url = `${baseURL}passreset`;
            await axios(config);
            commit(PASSWORDRESET);
        } catch (err) {
            console.log(err);
            commit(PASSRESETERROR);
        }
    },
    async setPassword({ commit }, config) {
        try {
            config.url = `${baseURL}setpassword`;
            await axios(config);
            commit(PASSWORDCHANGED);
        } catch (err) {
            console.log(err);
            commit(PASSWORDSETERROR);
        }
    },
    async socialLogin({ commit }, config) {
        try {
            config.url = `${baseURL}sociallogin`;
            await axios(config);
            var resp = await axios(config);
            console.log(resp);
            const token = resp.data.token;
            var user = resp.data.user;
            axios.defaults.headers.common["Authorization"] = token;
            commit(AUTH_SUCCESS, { token, user, msg: "Logga in framgång" });
        } catch (err) {
            commit(AUTH_ERROR, {
                msg:
                    "Inloggning misslyckades (ogiltigt användarnamn eller lösenord)"
            });
        }
    },

    async getScheduleDetails({ commit }, config) {
        config.url = `${baseURL}getscheduledetails`;
        console.log(config);
        let resp = await axios(config);
        commit("SHOWSCHEDULE", resp.data);
        console.log(resp);
    },

    async addParticipant({ commit }, config) {
        config.url = `${baseURL}addparticipant`;
        await axios(config);
        commit("PARTICIPANTADDED");
    },

    adminRegister({ commit }, user) {
        user.url = `${baseURL}register`;
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios(user)
                .then(resp => {
                    const token = resp.data.token;
                    user = resp.data.user;
                    axios.defaults.headers.common["Authorization"] = token;
                    commit(AUTH_SUCCESS, {
                        token,
                        user,
                        msg: "Registrering framgång"
                    });
                    resolve(resp);
                })
                .catch(err => {
                    console.log(err);
                    commit(AUTH_ERROR, {
                        msg: "Administratörsregistrering misslyckades"
                    });
                    localStorage.removeItem("token");
                    reject(err);
                });
        });
    },

    async deleteUser({ commit }, id) {
        let url = `${baseURL}deleteuser/${id}`;
        await axios.get(url);
        commit("USERDELETED");
    },

    async deleteSchedule({ commit }, id) {
        let url = `${baseURL}deleteschedule/${id}`;
        await axios.get(url);
        commit("SCHEDULEDELETED");
    },

    async changePassword({ commit }, config) {
        try {
            commit("LOADING");
            config.url = `${baseURL}admin/changepassword`;
            await axios(config);
            commit("PASSWORDCHANGED");
            commit("STOPLOADING");
        } catch (err) {
            commit("STOPLOADING");
        }
    },
    async Passwordchange({ commit }, config) {
        try {
            commit("LOADING");
            config.url = `${baseURL}admin/changepassword`;
            await axios(config);
            commit("PASSWORDCHANGED");
            commit("STOPLOADING");
        } catch (err) {
            commit("STOPLOADING");
        }
    },

    setEmail({ commit }, config) {
        commit("SETEMAIL", config);
    }
};

export default actions;
